import './toggleable_unapplied_filter_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.UnappliedFilterWithCheckbox extends Common.Dashboard.Filters.ToggleableUnappliedFilterView
  checkTemplate: JST['backbone/templates/common/dashboard/filters/options/filter_checkbox']
  selectAllTemplate: JST['backbone/templates/common/dashboard/filters/options/select_all_option']

  events: =>
    return _.extend({}, Common.Dashboard.Filters.ToggleableUnappliedFilterView.prototype.events, {
      'click .select_all_filter' : '_selectAllCheckboxes'
    })

  render: ->
    super()
    @_renderOptions()
    @_renderSelectAll()
    @_toogleApplyButton()
    @

  toggleOpenFilter: ->
    super()
    @$el.find('.select_all_filter').toggleClass('hidden')

  _selectAllCheckboxes: (event) ->
    event.stopPropagation()
    value = @$el.find('.checkbox-input').not(':checked').length > 0
    @$el.find('.checkbox-input').prop('checked', value)
    @_toogleApplyButton()

  _renderOptions: ->
    $filterBody = @$el.find('.filter-body')
    selectedIds = @filter.getValues().map (value) -> value.id
    for name, value of @filter.getPossibleValues()
      $filterBody.append @checkTemplate
        optionName: @_translateOptionName(name)
        optionValue: value
        checkedState: if value in selectedIds then 'checked' else ''
    $filterBody.find('.check input').change(@_toogleApplyButton)

  _renderSelectAll: ->
    @$el.find('.filter-title').append(@selectAllTemplate)

  _translateOptionName: ->
    throw new Error 'Not implemented'
